import PrintIcon from "@mui/icons-material/Print";
import { Box, IconButton } from "@mui/material";
import { ReactNode } from "react";
import Flex from "../../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../../components/Text";
import DeleteIcon from "../../../../../../../../../../components/app/DeleteIcon";

interface PreviewContentWrapperProps {
  dataList?: any;
  k: string;
  subK?: string;
  onEdit: (it: any) => void;
  onDelete?: (id: any) => void;
  onPrint?: (id: any) => void;
  renderContent?: (listItem: any) => ReactNode;
  disableCloseButton?: boolean;
  title?: string;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
const PreviewContentWrapper = ({
  dataList,
  onEdit,
  k,
  subK,
  onDelete,
  onPrint,
  disableCloseButton,
  renderContent,
  title,
}: PreviewContentWrapperProps) => {
  return (
    <Box>
      {title && (
        <Text
          sx={{
            fontWeight: "bold",
            color: "#424242",
            mb: 0.5,
          }}
        >
          {title}
        </Text>
      )}

      {dataList?.length ? (
        <Flex flexDirection={"column"} justifyContent={"center"} width={"100%"}>
          {dataList.map((item: any, index: number) => (
            <Flex key={item.uuid} width={"100%"}>
              <Text
                sx={{
                  fontWeight: "medium",
                  color: "#424242",
                  minWidth: "16px",
                }}
              >
                {index + 1}.
              </Text>

              <Flex
                key={item.uuid}
                gap={0.5}
                width={"100%"}
                sx={{
                  px: 0.3,
                  "&:hover": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
                alignItems={"center"}
              >
                <Flex
                  flex={1}
                  height={"100%"}
                  sx={{ cursor: "pointer" }}
                  onClick={() => onEdit(item)}
                >
                  {renderContent ? (
                    renderContent(item)
                  ) : (
                    <Text sx={{ color: "#424242" }}>
                      {subK ? item?.[k]?.[subK] : item?.[k]}
                    </Text>
                  )}
                </Flex>
                {onPrint && (
                  <IconButton
                    size="small"
                    sx={{ flexShrink: 0, zIndex: 1 }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation();
                      onPrint(item?.uuid);
                    }}
                  >
                    <PrintIcon color="disabled" fontSize="small" />
                  </IconButton>
                )}
                {!disableCloseButton && (
                  <DeleteIcon
                    size="small"
                    sx={{ flexShrink: 0, zIndex: 1 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete?.(item?.uuid);
                    }}
                  />
                )}
              </Flex>
            </Flex>
          ))}
        </Flex>
      ) : (
        <Text sx={{ color: "#757575", fontStyle: "italic" }}>
          No items to display
        </Text>
      )}
    </Box>
  );
};

export default PreviewContentWrapper;
